import { syncIcon } from "../../elements/icons/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import integrationFactory from "../../../models/integration/integrationFactory.js";
import OiIntegration from "../../../models/integration/OiIntegration.js";

/**
 * `fiscalYearImportWidget` displays an import button to import
 * fiscal years redirecting to the import page depending on the
 * company.
 */
function fiscalYearImportWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	let company = spec.company;
	const returnUrl = spec.returnUrl;
	let abortUrl = spec.abortUrl;
	const integrationTypes = spec.integrationTypes || [];

	that.setCompany = function (newCompany) {
		company = newCompany;
		that.update();
	};

	that.linkToCurrentImport = function () {
		return linkToIntegrationImport(currentIntegration());
	};

	that.setAbortUrl = function (url) {
		abortUrl = url;
		that.update();
	};

	that.getImportPathFor = function (integration) {
		return integration.importPath();
	};

	that.getImportQueryFor = function (integration) {
		return integration.importQuery();
	};

	that.getImportLabelFor = function (integration) {
		return integration.importButtonLabel();
	};

	that.renderContentOn = function (html) {
		buildAvailableIntegrations();

		html.div(
			{ klass: "fiscalYearImportWidget btn-group" },
			html.a(
				{
					klass: "btn btn-primary icon-and-text",
					"data-test": "import-button",
					href: that.linkToCurrentImport(),
				},
				syncIcon,
				that.getImportLabelFor(currentIntegration()),
			),
			(html) => {
				if (
					my.availableIntegrations.length <= 1 ||
					company.isProvisionedByOneClick()
				) {
					return;
				}

				html.button(
					{
						klass: "btn btn-primary dropdown-toggle",
						"data-test": "other-integrations-menu",
						"data-toggle": "dropdown",
						"aria-haspopup": true,
						"aria-expanded": false,
					},
					html.span({ klass: "caret" }),
					html.span({ klass: "sr-only" }, "Toggle Dropdown"),
				);
			},
			(html) => {
				if (!company) {
					return;
				}

				const otherIntegrations = company
					.otherIntegrations(my.availableIntegrations)
					.filter(
						(integration) =>
							integration.getType() !==
							currentIntegration().getType(),
					);

				if (otherIntegrations.length === 0) {
					return;
				}

				html.ul(
					{
						klass: "dropdown-menu pull-right fiscal-year-import-dropdown",
						"data-test": "import-selection-dropdown",
					},
					otherIntegrations.map(linkToImportRenderer),
				);
			},
		);
	};

	function buildAvailableIntegrations() {
		const allUpdatingImporters =
			integrationFactory.integrationsWithUpdatingImporters();

		my.availableIntegrations = allUpdatingImporters.filter(
			(importer) =>
				!integrationTypes.length ||
				integrationTypes.includes(importer.getType()),
		);
	}

	function currentIntegration() {
		if (company.isProvisionedByOneClick()) {
			return new OiIntegration();
		}
		return (
			(company && company.getCurrentImportIntegration()) ||
			my.availableIntegrations[0]
		);
	}

	function linkToImportRenderer(integration) {
		return function (html) {
			html.li(
				{ klass: "fiscal-year-import-option" },
				html.a(
					{
						href: linkToIntegrationImport(integration),
					},
					that.getImportLabelFor(integration),
				),
			);
		};
	}

	function linkToIntegrationImport(integration) {
		const path = that.getImportPathFor(integration);
		const query = that.getImportQueryFor(integration);

		Object.assign(query, {
			isExistingLightCompany: false,
			returnUrl,
			abortUrl,
		});

		if (company) {
			Object.assign(query, {
				isExistingLightCompany: company.isLightCompany(),
				businessIdentityCode: company.getBusinessIdentityCode(),
			});
		}

		return my.router.linkTo(path, query);
	}

	return that;
}

export default fiscalYearImportWidget;
